import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { GearGridCell } from './GearGridCell';
import { EMPTY_VALUE } from '../../../config/consts';

const renderPills = (value: unknown): React.ReactNode => {
  if (!value) {
    return null;
  }

  if (Array.isArray(value)) {
    return (
      <div>
        {value.map((item, index) => (
          <div key={`${item}-${index}`} className="pill">
            {item}
          </div>
        ))}
      </div>
    );
  }

  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    React.isValidElement(value)
  ) {
    return value;
  }

  return String(value);
};

export const MultiChoiceCell = (props: GridCellProps) => {
  const field = props.field || EMPTY_VALUE;
  const value = props.dataItem[field];

  return (
    <GearGridCell {...props} title="">
      {renderPills(value)}
    </GearGridCell>
  );
};
